import { usePageSizeActions } from './usePageSizeActions';
import { usePageSizeState } from './usePageSizeState';

export const usePageSizeReducer = () => ({
  ...usePageSizeActions(),
  ...usePageSizeState(),
});
